import { API, get, put } from 'utils/api';
import { isDateRangeEmpty } from '../utils/general';

import {
  DateRange,
  StorySnippet
} from '../types';

export const getStoriesForDeliverable = async (
  deliverableId: number
): Promise<Array<StorySnippet>> => {
  const url = API.END_POINTS.DELIVERABLE.getDeliverableStories(deliverableId);

  const response = await get(url);

  return response.data;
};

export const searchStoriesForDeliverable = async (
  deliverableId: number,
  dates?: DateRange,
  searchBy?: Array<string>
): Promise<Array<StorySnippet>> => {
  let url = API.END_POINTS.DELIVERABLE.searchDeliverableStories(deliverableId);
  url = `${url}?items_per_page=250&page=1`;
  url = dates && !isDateRangeEmpty(dates)
    ? `${url}&start_date=${dates[0]}&end_date=${dates[1]}`
    : url;
  url = searchBy && searchBy.length > 0 ? `${url}&search_term=${searchBy.join(',')}` : url;

  const response = await get(url);

  return response.data.data;
};

const updateStorySnippets = async (
  deliverableId: number,
  storiesToAdd: Array<string>,
  storiesToDelete: Array<string>
): Promise<Array<StorySnippet>> => {
  const url = API.END_POINTS.DELIVERABLE.modifyDeliverableStoriesList(deliverableId);
  const data = {
    storiesToAdd,
    storiesToDelete
  };

  const response = await put(url, { data });

  return response.data;
};

export const saveStorySnippets = (
  deliverableId: number,
  addStoryCodes: Array<string>,
  deleteStoryCodes: Array<string>
) => updateStorySnippets(deliverableId, addStoryCodes, deleteStoryCodes);

export const deleteStorySnippets = (
  deliverableId: number,
  storyCodes: Array<string>
) => updateStorySnippets(deliverableId, [], storyCodes);
